import { useId, useState } from 'react';
import { Label } from '~/components/ui/label';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/components/ui/alert-dialog';
import { parentStudentStatus, STUDENT_STATUSES } from '../ParentEnrollment/parentStudentStatus';

interface StudentStatusMenuProps {
  studentName: string;
  state: string;
  saving?: boolean;
  /** Hides the visible label, for a table cell whose column already says it. */
  compact?: boolean;
  onConfirm: (status: string) => void;
}

// The office may set any status; there are no transitions to respect. One
// menu serves the student's page and the family's.
export function StudentStatusMenu({ studentName, state, saving = false, compact = false, onConfirm }: StudentStatusMenuProps) {
  const [pending, setPending] = useState<string | null>(null);
  const selectId = useId();

  return (
    <div className="space-y-1">
      {!compact && <Label htmlFor={selectId} className="text-xs text-muted-foreground">Set status</Label>}
      <select
        id={selectId}
        aria-label={compact ? `Set status for ${studentName}` : 'Set status'}
        className="h-8 w-full rounded-md border border-input bg-background px-2 text-sm"
        value={state}
        disabled={saving}
        onChange={(event) => setPending(event.target.value)}
      >
        {STUDENT_STATUSES.map((status) => (
          <option key={status} value={status}>{parentStudentStatus(status)}</option>
        ))}
      </select>

      <AlertDialog open={pending !== null} onOpenChange={(open) => !open && setPending(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Change status</AlertDialogTitle>
            <AlertDialogDescription>
              Change {studentName} from <strong>{parentStudentStatus(state)}</strong> to{' '}
              <strong>{pending ? parentStudentStatus(pending) : ''}</strong>?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                if (pending) onConfirm(pending);
                setPending(null);
              }}
            >
              Change status
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}

export default StudentStatusMenu;
